
export const DarkTheme = {
  color: {
    // COLORS
    white: {
      _default: "#ffffff",
      alpha: {
        _default: "rgba(255,255,255, 0.5)",
      }
    },
    black: {
      _default: "#0b0b0d",
      alpha: {
        _default: "rgba(11,11,13, 0.5)",
      }
    },
    gray: {
      _default: "#393b40",
      alpha: {
        _default: "rgba(57,59,64, 0.5)",
      }
    },
    red: {
      _default: "#ef5559",
      alpha: {
        _default: "rgba(255,91,79, 0.3)",
      }
    },
    orange: {
      _default: "#ff9f0a",
      alpha: {
        _default: "rgba(255,159,10,0.3)",
      }
    },
    yellow: {
      _default: "#f1c90d",
      alpha: {
        _default: "rgba(241,201,13,0.3)",
      }
    },
    green: {
      _default: "#4ed07b",
      alpha: {
        _default: "rgba(48,209,88, 0.3)",
      }
    },
    mint: {
      _default: "#66d4cf",
      alpha: {
        _default: "rgba(102,212,207,0.3)",
      }
    },
    teal: {
      _default: "#40c8e0",
      alpha: {
        _default: "rgba(64,200,224,0.3)",
      }
    },
    cyan: {
      _default: "#64d2ff",
      alpha: {
        _default: "rgba(100,210,255,0.3)",
      }
    },
    blue: {
      _default: "#0a84ff",
      alpha: {
        _default: "rgba(10,132,255, 0.3)",
      }
    },
    indigo: {
      _default: "#5e5ce6",
      alpha: {
        _default: "rgba(94,92,230,0.3)",
      }
    },
    purple: {
      _default: "#bf5af2",
      alpha: {
        _default: "rgba(191,90,242,0.3)",
      }
    },
    pink: {
      _default: "#ff375f",
      alpha: {
        _default: "rgba(255,55,95,0.3)",
      }
    },
    brown: {
      _default: "#ac8e68",
      alpha: {
        _default: "rgba(172,142,104,0.3)",
      }
    },

    // FILL
    fill: {
      _default: {
        _default: "#1c1d21",
        alpha: {
          _default: "rgba(28,29,33, 0.5)",
        }
      },
      2: {
        _default: "#282a2d",
        alpha: {
          _default: "rgba(43,45,48, 0.5)",
        }
      },
      3: {
        _default: "#393b40",
        alpha: {
          _default: "rgba(57,59,64, 0.5)",
        }
      },
      4: {
        _default: "#4e5157",
        alpha: {
          _default: "rgba(78,81,87, 0.5)",
        }
      },
    },
    // TEXT
    text: {
      _default: "rgba(235, 235, 245, 1)",
      2: "rgba(235, 235, 245, 0.6)",
      3: "rgba(235, 235, 245, 0.3)",
      4: "rgba(235, 235, 245, 0.18)",
    },
    textReverse: {
      _default: "rgba(11,11,13, 1)",
      2: "rgba(11,11,13, 0.6)",
      3: "rgba(11,11,13, 0.3)",
      4: "rgba(11,11,13, 0.18)",
    },
    scrollbar: {
      _default: "#6d6d72"
    },
    border: {
      _default: "#393b40",
      reverse: "#1c1d21"
    },
    panel: {
      _default: "var(--colorFill2)",
    },
    link: {
      _default: "#76b3ff",
      dark: "#80a2cd"
    },
    accent: {
      _default: "#0a84ff"
    }
  },
} as const
